import { Fragment, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouteComponentProps } from "../../models/RouteComponent";
import { Card } from "primereact/card";
import { Grid } from "@mui/material";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import AccessLevelTree from "../../components/AccessLevelTree";
import { accessLevelAdd, accessLevelUpdate } from "../../service/accessLevelService";
import { Input } from "../../components/Shared/Forms";

export default function AccessLevelsView(props: RouteComponentProps) {
  const navigate = useNavigate();

  const accessLevel = props.accessLevel;
  const clientID = props.session.client_id;

  const [name, setName] = useState(accessLevel?.name || "");
  const [isAdmin] = useState(accessLevel?.is_admin || false);
  const [polices, setPolices] = useState({
    changes: false,
    policies: accessLevel?.policies || ([] as string[]),
  });

  const toast = useRef(null as any);

  const record_id = accessLevel?.id;

  async function updateAccessLevel() {
    const updateObject: any = {
      name: name,
      policies: polices.policies,
      is_admin: isAdmin,
    };
    if (clientID && clientID !== "") {
      updateObject.client = clientID;
    }
    props.setGlobalLoader(true);
    if (record_id) {
      accessLevelUpdate(updateObject, record_id).then((r: any) => {
        props.setGlobalLoader(false);
        navigate("/access-level-table");
        toast.current.show({
          severity: "success",
          summary: "Access Level Updated Successfully",
          life: 3000,
        });
      });
      return;
    }
    accessLevelAdd(updateObject).then((r: any) => {
      props.setGlobalLoader(false);
      navigate("/access-level-table");
      toast.current.show({
        severity: "success",
        summary: "Access Level Added Successfully",
        life: 3000,
      });
    });
  }

  return (
    <Fragment>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          type="button"
          icon="pi pi-save"
          label="Save"
          className="p-button-outlined"
          size="small"
          style={{ fontSize: "small", color: "#2dd36f" }}
          onClick={() => updateAccessLevel()}
        />
      </div>
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder={"Please enter access level name"}
              label={"Access Level Name"}
            />
          </Grid>
        </Grid>
        <br />
        <AccessLevelTree isPortal={isAdmin} policies={polices} setPolicies={setPolices} />
      </Card>

      <Toast ref={toast} />
    </Fragment>
  );
}
